import { render } from "./TariffCard.vue?vue&type=template&id=e5b51b7a&scoped=true"
import script from "./TariffCard.vue?vue&type=script&lang=js"
export * from "./TariffCard.vue?vue&type=script&lang=js"

import "./TariffCard.vue?vue&type=style&index=0&id=e5b51b7a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b51b7a"]])

export default __exports__